import React from "react";
import Sidebar from "../partials/aside/Sidebar";
import TitleBar from "../partials/content/TitleBar";

export default function Welcome() {
  return (
    <>
      <Sidebar activeItem="welocome" />

      <div className="content-wrapper">
        <TitleBar title="میزکار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <p className="alert alert-success">
                <h1 className="text-dark"> همراه گرامی سلام</h1>
                <p className="text-justify text-dark pt-3">
                  در این بخش پیام های سیستمی و مدیریتی پلتفرم تبلیغات آنلاین
                  هایلایت نمایش داده می شود.
                </p>
                <p className="text-justify text-dark">
                  همچنین آموزش های لازم و ضروری نیز در این بخش به شما عزیزان
                  ارائه می گردد.
                </p>
                <p className="text-justify text-dark">
                  تیم پشتیبانی هایلایت در هر زمان آماده پاسخگویی به شما هستند
                  لطفا جهت ارتباط از بخش پشتیبانی درخواست ثبت کنید.
                </p>
                <p className="text-justify text-dark">با تشکر هایلایت</p>
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
